import axios from 'axios'
import qs from 'qs';
import Vue from 'vue';
import jsonBig from 'json-bigint'
import {
	Toast
} from 'vant';
Vue.use(Toast);
// var json = '{ "value" : 303702854256820224, "v2": 123 }'
// console.log(jsonBig.parse(json))
// var aa=jsonBig.parse(json)
// console.log(aa.value.toString())

// 创建axios实例
const service = axios.create({
	baseURL: '',
	timeout: 5000, // timeout
	transformResponse: [function (data) {
		try {
			// 如果转换成功则返回转换的数据结果
			return jsonBig.parse(data)
		} catch (err) {
			// 如果转换失败，则包装为统一数据格式并返回
			return {
				data
			}
		}
	}]
})
// request拦截器
service.interceptors.request.use(
	config => {
		config.method === 'post'
			? config.data = qs.stringify({ ...config.data })
			: config.params = { ...config.params };
		config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
		// config.headers['Access-Token'] = token;
		return config
	},
	error => {
		console.log(error)
		Toast(error);
		return Promise.reject(error)
	}
)

// respone拦截器
service.interceptors.response.use(
	response => { //成功请求到数据
		// console.log(response)
		const res = response.data;
		if (Object.prototype.toString.call(res) === '[Object Object]' && res.hasOwnProperty('errno')) {
			res.code = res.errno
			delete res.errno;
		}
		if (res.code != 200) {
			// Toast(res.msg || 'Error');
			return Promise.reject(new Error(res.msg || 'Error'))
		} else {
			return res
		}
	},
	error => { //响应错误处理
		console.log(error)
		Toast(error);
		return Promise.reject(error)
	}
)

export default service
